import React from "react";
import PropTypes from "prop-types";
import Nav from "react-bootstrap/Nav";
import NavItem from "react-bootstrap/NavItem";
import NavLink from "react-bootstrap/NavLink";
import Navbar from "react-bootstrap/Navbar";
import NavbarCollapse from "react-bootstrap/NavbarCollapse";
import NavbarToggle from "react-bootstrap/NavbarToggle";
import Container from "react-bootstrap/Container";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownToggle from "react-bootstrap/DropdownToggle";
import DropdownMenu from "react-bootstrap/DropdownMenu";
import DropdownItem from "react-bootstrap/DropdownItem";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import NavbarBrand from "react-bootstrap/NavbarBrand";

import { HotjarMasked } from "@a0/support-center-components";
import { truncate } from "lodash";

import resources from "../../../utils/resources";
import { LogOut } from "react-feather";
import { SalesforceAwareLink } from "./SalesforceAwareLink";
import { OngoingChangesBanner } from "./OngoingChangesBanner";

const auth0Logo = require("../../../img/auth0_2025_badge.svg");
const supportLogo = require("../../../img/support_center_2025.svg");

const Header = ({ auth, contactSales }) => {
  const manageUrl = window.scConfig.MANAGE_URL;
  const statusPageUrl = window.scConfig.STATUS_PAGE_URL;
  return (
    <header className="site-header">
      <Navbar role="navigation" variant="default" expand={false}>
        <Container>
          <div className="navbar-header">
            <NavbarBrand as="h1">
              {/* onlyActiveOnIndex behaves like "IndexLink": it makes the home route
              active only if the path matches exactly */}
              <SalesforceAwareLink
                to="/"
                activeClassName="active"
                onlyActiveOnIndex
              >
                <div className="brand-image">
                  <img className="auth0-logo" src={auth0Logo} />
                  <img className="support-logo" src={supportLogo} />
                </div>
              </SalesforceAwareLink>
            </NavbarBrand>
            <NavbarToggle
              bsPrefix="navbar-toggle"
              aria-controls="responsive-navbar-nav"
            >
              {[1, 2, 3].map((e) => (
                <span key={e} className="icon-bar"></span>
              ))}
            </NavbarToggle>
          </div>
          <NavbarCollapse className="container">
            <Nav as="ul" className="nav navbar-right">
              <NavItem as="li">
                <NavLink target="_blank" href={manageUrl}>
                  Dashboard
                </NavLink>
              </NavItem>
              <NavItem as="li">
                <NavLink target="_blank" href="https://auth0.com/docs">
                  Documentation
                </NavLink>
              </NavItem>
              <NavItem as="li">
                <NavLink target="_blank" href={statusPageUrl}>
                  Status
                </NavLink>
              </NavItem>
              <NavItem as="li">
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip id="tooltip" className="bottom">
                      {resources.CONTACT_SALES_TOOLTIP}
                    </Tooltip>
                  }
                >
                  <NavLink
                    href="#"
                    onClick={function (e) {
                      contactSales(e, {
                        place: "header",
                        type: "link",
                        text: "talk to sales"
                      });
                    }}
                  >
                    Talk to Sales
                  </NavLink>
                </OverlayTrigger>
              </NavItem>
              {auth.isAuthenticated ? (
                <Dropdown as="li" style={{ marginTop: "-3px" }}>
                  <DropdownToggle as={NavLink} id="nav-dropdown" role="button">
                    <span>
                      {auth.user.picture && (
                        <img
                          src={auth.user.picture}
                          className="picture avatar ac-avatar"
                        />
                      )}
                    </span>
                  </DropdownToggle>
                  <DropdownMenu as="ul">
                    <DropdownItem
                      as="li"
                      className="dropdown-email username-text text-truncate"
                    >
                      <div className="navbar-text">
                        {auth.user.picture && (
                          <img
                            src={auth.user.picture}
                            className="picture avatar ac-avatar ac-avatar--inside"
                          />
                        )}
                        <HotjarMasked isInline>
                          <strong
                            style={{ marginRight: "20px" }}
                            title={auth.user.email}
                          >
                            {truncate(auth.user.email)}
                          </strong>
                        </HotjarMasked>
                      </div>
                    </DropdownItem>
                    <DropdownItem as="li">
                      <NavLink href="/logout">
                        <LogOut className="logout-icon" /> Logout
                      </NavLink>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              ) : (
                <NavItem as="li">
                  <NavLink href="/login">
                    <span className="btn btn-primary btn-sm btn-login no-padding-right">
                      <span>Log in</span>
                    </span>
                  </NavLink>
                </NavItem>
              )}
            </Nav>
          </NavbarCollapse>
        </Container>
        <OngoingChangesBanner />
      </Navbar>
    </header>
  );
};

Header.propTypes = {
  auth: PropTypes.object.isRequired,
  contactSales: PropTypes.func.isRequired
};

export default Header;
